// https://en.wikipedia.org/wiki/Single_Euro_Payments_Area
// For SEPA states, we have to also collect names / addresses / id documents for
// anybody with more than 25% ownership of the company. Implementing this is a
// massive PITA, so we'll filter this for now...
const sepaCountries = [
  'AT',
  'BE',
  'DK',
  'FI',
  'FR',
  'DE',
  'IE',
  'IT',
  'LU',
  'NL',
  'NO',
  'SP',
  'SE',
  'GB',
];

const supportedCountryList = [
  {
    name: 'Australia',
    code: 'AU',
    status: '',
    bankMode: 'BSB',
    bankCurrencies: ['AUD'],
    className: 'australia',
  },
  {
    name: 'Austria',
    code: 'AT',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'austria',
  },
  {
    name: 'Belgium',
    code: 'BE',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'belgium',
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['BGN', 'EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'bulgaria',
  },
  {
    name: 'Canada',
    code: 'CA',
    status: '',
    bankMode: 'TRANSIT',
    bankCurrencies: ['CAD', 'USD'],
    className: 'canada',
  },
  {
    name: 'Cyprus',
    code: 'CY',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'cyprus',
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['CZK', 'EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'czech-republic',
  },
  {
    name: 'Denmark',
    code: 'DK',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'denmark',
  },
  {
    name: 'Estonia',
    code: 'EE',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'estonia',
  },
  {
    name: 'Finland',
    code: 'FI',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'finland',
  },
  {
    name: 'France',
    code: 'FR',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'france',
  },
  {
    name: 'Germany',
    code: 'DE',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'germany',
  },
  {
    name: 'Greece',
    code: 'GR',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'greece',
  },
  {
    name: 'Hong Kong',
    code: 'HK',
    status: '',
    bankMode: 'CBA',
    bankCurrencies: ['HKD'],
    className: 'hong-kong',
  },
  {
    name: 'Hungary',
    code: 'HU',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['HUF', 'EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'hungary',
  },
  {
    name: 'Ireland',
    code: 'IE',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'ireland',
  },
  {
    name: 'Italy',
    code: 'IT',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'italy',
  },
  {
    name: 'Japan',
    code: 'JP',
    status: '',
    bankMode: 'FULL',
    bankCurrencies: ['JPY'],
    className: 'japan',
  },
  {
    name: 'Latvia',
    code: 'LV',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'latvia',
  },
  {
    name: 'Lithuania',
    code: 'LT',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'lithuania',
  },
  {
    name: 'Luxembourg',
    code: 'LU',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'luxembourg',
  },
  // { name: 'Malaysia', code: 'MY', status: '', bankMode: 'AN', bankCurrencies: ['MYR'], className: 'malaysia' },
  {
    name: 'Malta',
    code: 'MT',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'malta',
  },
  // { name: 'Mexico', code: 'MX', status: '', bankMode: 'CLABE', bankCurrencies: ['MXN'], className: 'mexico' },
  {
    name: 'Netherlands',
    code: 'NL',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'netherlands',
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    status: '',
    bankMode: 'AN',
    bankCurrencies: ['NZD'],
    className: 'new-zealand',
  },
  {
    name: 'Norway',
    code: 'NO',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'norway',
  },
  {
    name: 'Poland',
    code: 'PL',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['PLN', 'EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'poland',
  },
  {
    name: 'Portugal',
    code: 'PT',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'portugal',
  },
  {
    name: 'Romania',
    code: 'RO',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['RON', 'EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'romania',
  },
  {
    name: 'Singapore',
    code: 'SG',
    status: '',
    bankMode: 'BBA',
    bankCurrencies: ['SGD'],
    className: 'singapore',
  },
  {
    name: 'Slovakia',
    code: 'SK',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'slovakia',
  },
  {
    name: 'Slovenia',
    code: 'SI',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'slovenia',
  },
  {
    name: 'Spain',
    code: 'ES',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'spain',
  },
  {
    name: 'Sweden',
    code: 'SE',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'sweden',
  },
  {
    name: 'Switzerland',
    code: 'CH',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'switzerland',
  },
  {
    name: 'United Kingdom',
    code: 'GB',
    status: '',
    bankMode: 'IBAN',
    bankCurrencies: ['EUR', 'CHF', 'DKK', 'GBP', 'NOK', 'SEK', 'USD'],
    className: 'united-kingdom',
  },
  {
    name: 'United States',
    code: 'US',
    status: '',
    bankMode: 'ROUTE',
    bankCurrencies: ['USD'],
    className: 'united-states',
  },
];

type ManagedBilling = {
  sepaCountries: string[];
  supportedCountryList: Array<{
    name: string;
    code: string;
    status: string;
    bankMode: string;
    bankCurrencies: string[];
    className: string;
  }>;
};

export const managedBilling: ManagedBilling = {
  sepaCountries,
  supportedCountryList,
};
